import { Component } from '@angular/core';

@Component({
    selector: 'app-circle-edit',
    template: `
        <app-custom-circle-icon color="warning-color">
            <i class="material-icons" icon>edit</i>
        </app-custom-circle-icon>
    `,
})
export class CircleEditComponent {}
